import moment from 'moment';

export default {
  diasUteisVeiculoNovo() {
    return 3;
  },

  /**
   * Converte data padrão brasileiro em formato ISO
   * @param {string} value string formatada dd/mm/yyyy
   * @returns retorna data no formato iso yyyy-mm-dd
   */
  convertDateToISO(value) {
    if (value) {
      const [day, month, year] = value.split('/');
      if (day && month && year) {
        const result = `${year}-${month}-${day}`;
        return result;
      }
    }
    return null;
  },

  /**
   * Converte data padrão ISO em formato brasileiro
   * @param {string} value string formatada yyyy-mm-dd[THH:mm:ss]
   * @returns retorna data no formatado brasileiro dd/mm/yyyy
   */
  converteISOToDate(value) {
    if (!value) {
      return null;
    }

    const positionT = value.indexOf('T');
    if (positionT > 0) {
      value = value.split('T')[0];
    }

    const [year, month, day] = value.split('-');
    if (day && month && year) {
      const result = `${day}/${month}/${year}`;
      return result;
    }
    return null;
  },
  formataStringData(data) {
    const dia = data.split('/')[0];
    const mes = data.split('/')[1];
    const ano = data.split('/')[2];

    return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2);
    // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
  },
  calcularPascoa(ano) {
    const a = ano % 19;
    const b = Math.floor(ano / 100);
    const c = ano % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mes = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    const dia = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(ano, mes, dia);
  },
  diasUteis(dataInicial, dataFinal, feriados) {
    // Cria cópias das datas para evitar modificar os parâmetros originais
    let dataInicio = new Date(dataInicial.getTime());
    let dataFim = new Date(dataFinal.getTime());

    // Garante que a data inicial seja anterior à data final
    if (dataInicio > dataFim) {
      [dataInicio, dataFim] = [dataFim, dataInicio];
    }

    // Calcula o número de milissegundos por dia
    const umDia = 24 * 60 * 60 * 1000;

    // Inicializa o contador de dias úteis
    let diasUteis = 0;

    // Percorre as datas a partir da data inicial
    while (dataInicio <= dataFim) {
      // Verifica se a data é um feriado
      const feriado = feriados.find(
        (d) => d.toString().slice(0, 15) === dataInicio.toString().slice(0, 15),
      );
      // Verifica se a data é um dia útil (não é sábado, domingo ou feriado)
      if (dataInicio.getDay() !== 0 && dataInicio.getDay() !== 6 && !feriado) {
        diasUteis++;
      }

      // Incrementa a data em um dia
      dataInicio.setTime(dataInicio.getTime() + umDia);
    }

    // Retorna o número de dias úteis
    return diasUteis;
  },
  feriadosDoAno() {
    const ano = new Date().getFullYear();

    const feriadosFixos = [
      new Date(ano, 0, 1), // Confraternização Universal
      new Date(ano, 3, 21), // Tiradentes
      new Date(ano, 4, 1), // Dia do Trabalhador
      new Date(ano, 8, 7), // Independência do Brasil
      new Date(ano, 9, 12), // Nossa Senhora Aparecida
      new Date(ano, 10, 2), // Finados
      new Date(ano, 10, 15), // Proclamação da República
      new Date(ano, 11, 25), // Natal
    ];

    const pascoa = this.calcularPascoa(ano); // Pascoa
    const carnaval = new Date(
      pascoa.getFullYear(),
      pascoa.getMonth(),
      pascoa.getDate() - 46,
    ); // Carnaval
    const sextaFeiraSanta = new Date(
      pascoa.getFullYear(),
      pascoa.getMonth(),
      pascoa.getDate() - 2,
    ); // Sexta Feira Santa
    const corpusChristi = new Date(
      pascoa.getFullYear(),
      pascoa.getMonth(),
      pascoa.getDate() + 60,
    ); // Corpus Christi

    return [...feriadosFixos, carnaval, pascoa, sextaFeiraSanta, corpusChristi];
  },
  verificarSaidaNotaFiscal(dataNotaFiscalSaida) {
    const diasUteisVeiculoNovo = this.diasUteisVeiculoNovo();
    const feriados = this.feriadosDoAno();
    const dataAtual = new Date();

    const _dataNotaFiscalSaida = this.formataStringData(dataNotaFiscalSaida);
    const _dataNotaFiscalSaidaFormatada = new Date(_dataNotaFiscalSaida);

    const numerodiasUteis = this.diasUteis(
      _dataNotaFiscalSaidaFormatada,
      dataAtual,
      feriados,
    );

    const veiculoZero = numerodiasUteis < diasUteisVeiculoNovo ? true : false;
    return veiculoZero;
  },
  proximoDiaUtil() {
    const feriados = this.feriadosDoAno();
    const dataAtual = new Date();
    const dataFinal = new Date().setDate(new Date().getDate() + 3);

    // Calcula o número de milissegundos por dia
    const umDia = 24 * 60 * 60 * 1000;
    let isUtil = false;
    dataAtual.setTime(dataAtual.getTime() + umDia);

    // Percorre as datas a partir da data inicial
    while (dataAtual <= dataFinal) {
      console.log('Data =>', dataAtual, isUtil);
      // Verifica se a data é um feriado
      const feriado = feriados.find(
        (d) => d.toString().slice(0, 15) === dataAtual.toString().slice(0, 15),
      );
      // Verifica se a data é um dia útil (não é sábado, domingo ou feriado)
      if (dataAtual.getDay() !== 0 && dataAtual.getDay() !== 6 && !feriado) {
        // Incrementa a data em um dia

        isUtil = true;
        break;
      } else {
        dataAtual.setTime(dataAtual.getTime() + umDia);
      }
    }
    //console.log(dataAtual);
    return dataAtual;
  },
  convertISOToDateHour(value) {
    return moment(value).utc().format('DD/MM/YYYY HH:mm');
  },
};
